import 'core-js'
import 'airbnb-browser-shims'
import 'react-app-polyfill/ie11'
import 'react-app-polyfill/stable'

import React from 'react'
import { render } from 'react-dom'
import { Provider } from 'react-redux'
import configureStore from './reducers/configuration/store'
import App from './containers/App'

import './styles/css/base/normalize.css'
import './styles/css/base/base.css'
import './styles/css/vendor/flexboxgrid.css'
import './styles/css/base/flexboxgrid-overrides.css'
import './styles/css/base/mui-overrides.css'
import './styles/css/base/typography.css'
import './styles/css/base/buttons.css'
import './styles/css/base/utilities.css'
import './styles/css/base/calendar.css'
import './styles/css/base/forms.css'
import './styles/css/theme/theme-base.css'
import fetchConfiguration from '../src/actions/fetchConfiguration'
import WebFont from 'webfontloader'
import {isEmpty} from "lodash";

WebFont.load({
	google: {
		families: ['Material Icons']
	}
})

const setCustomFonts = () => {
	const queryString = require('query-string')
	const hotelCode = queryString.parse(window.location.search).hotelCode
	let serif, sansSerif
	switch(hotelCode) {
		case '3167':
		case 'B8X5':
		case 'B8Y1':
			serif = "Cheltenham-light, serif"
      		sansSerif = 'PPMori, sans-serif';
			break;
		default:
			break;
	}
	if (serif && sansSerif) {
		document.body.style.setProperty('--font-serif-stack', serif)
		document.body.style.setProperty('--font-sans-serif-stack', sansSerif)
		document.body.style.setProperty('--font-sans-serif-stack-light', sansSerif)
		document.body.style.setProperty('--font-sans-serif-stack-bold', sansSerif)
	}
}
setCustomFonts()

const configureRoomGuestData = () => {
	const queryString = require('query-string')
	const urlQuery = queryString.parse(window.location.search)
	let guestData = JSON.parse(window.localStorage.getItem('flowGuestData'))
	// update flowGuestData to include the multi-room info passed in the query params
	if (urlQuery.numRooms && guestData) {
		let i = 1
		while (i <= urlQuery.numRooms) {
			const adultsKey = `adults${i}`
			const childKey = `children${i}`

			if (urlQuery[adultsKey]) {
				const adults = parseInt(urlQuery[adultsKey], 10)
				const child = parseInt(urlQuery[childKey], 10) || 0
				// only want to add new element if it doesn't already exist, if it does exist we want to edit it using the edit stay component
				if (isEmpty(guestData[i])) {
					guestData[i] = {"adults": adults, "children": child, "dogs": false, "cats": false}
				}
				i++
			} else {
				break
			}
		}
		try {
			localStorage.setItem('flowGuestData', JSON.stringify(guestData))
		} catch (error) {
			console.error("Error saving additional room guests to flowGuestData", error)
		}
	}
}
configureRoomGuestData()

const store = configureStore()
store.dispatch(fetchConfiguration())

const renderApp = () => 
	render(
		<Provider store={store}>
			<App />
		</Provider>,
		document.getElementById('bk-flow')
	)

	if (process.env.NODE_ENV !== 'production' && module.hot) {
		module.hot.accept('./containers/App', renderApp)
	}

renderApp()



// WEBPACK FOOTER //
// ./src/index.js